import styled from 'styled-components';
import { Autocomplete } from '../../../../../../components/Common/create-position-autocomplete/autocomplete.component';

export const CustomAutocomplete = styled(Autocomplete)`
  font-size: 24px;
  
  & .input-wrapper {
    height: 32px;
  }
`;
